<script lang="ts">
  import { Row, Col } from "sveltestrap";
  export let imgData: { src: string; alt: string };
  export let inverted: boolean = false;
  const { src, alt } = imgData;
</script>

<div class="feature-section">
  <Row class="h-100 justify-content-center align-items-center">
    <Col sm="5" class={inverted ? "order-sm-2" : ""}>
      <img {src} {alt} />
    </Col>
    <Col sm="5" class={inverted ? "order-sm-1" : ""}>
      <slot />
    </Col>
  </Row>
</div>

<style>
  img {
    max-width: 500px;
    width: 100%;
  }
  .feature-section {
    margin-top: 50px;
  }
</style>
